export default __webpack_public_path__ + "static/media/marquee1.ebc6410b.png";